// removed by extract-text-webpack-plugin
module.exports = {"component":"_2mTVthmtFMuU_XTcg0gp0P"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Cart/Templates/Hotsite/MultiStep/Logo/logo.css
// module id = 1063
// module chunks = 2